import Main from './ServicesMain'
import WaitingApproval from './ServicesWaitingApproval'
import Show from './ServiceShow'

const partnerServices = { Main, WaitingApproval, Show }

export default partnerServices
